import { useState } from 'react';
import { useNavigate} from 'react-router-dom';
import { Button, Container, Row } from 'react-bootstrap';
import CountryCard from './CountryCard';
import { Backdrop, CircularProgress } from '@mui/material';

const CountryList = ({ countries, isLoading }) => {
    const [showAll, setShowAll] = useState(false);
    
    const countriesToDisplay = showAll ? countries : countries.slice(0, 4 * 4);

    const navigate = useNavigate();
    const handleShowAll = () => {
        setShowAll(prevShowAll => !prevShowAll);
    };

    const handleCountryClick = async (country) => {
       
        navigate("country_wise_plans", { state: { country } });

    };

    return (
        <>
            <div className='container-fluid '>

                <Container>
                    <Row className='mt-4'>
                      <>
                            {isLoading ? (
                                <Backdrop
                                open={true}
                                style={{
                                    color: '#fff',
                                    zIndex: 9999,
                                }}
                            >
                                <CircularProgress color="inherit" />
                            </Backdrop>
                            ) : (
                                <>

                                    {countriesToDisplay.map((country, index) => (
                                        <CountryCard
                                            key={index}
                                            country_name_slug={country.country_name_slug}
                                            country_name={country.country_name}
                                            flag_image={country.flag_image}
                                            isLoading={isLoading}
                                            onClick={() => handleCountryClick(country)}

                                        />
                                    ))}

                                </>
                            )}
                        </>
                        <div className="text-center mt-4">
                        <center><Button className='show-more-btn' variant="dark" size="lg" onClick={handleShowAll}>
                            {showAll ? 'Show Fewer Countries' : 'Show 200+ Countries'}
                        </Button></center>
                    </div>
                    </Row>
                </Container>
            </div>
        </>);
}

export default CountryList;